import { createSelector } from 'reselect';

const domain = state => state.auth;

export const isLoggingIn = createSelector(domain, auth => auth.isLoggingIn);

export const error = createSelector(domain, auth => auth.error);
